"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _loginContext = require("./loginContext");
Object.keys(_loginContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _loginContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _loginContext[key];
    }
  });
});
